import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Assetversionslist from "../AssetVersionsList/Assetversionslist.component";
import useStyles from "./AssetVersionDefaultTable.styles";

const AssetVersionDefaultTable = ({
  assetVersionList,
  tableRef,
  scrollValue,
  taskList,
  fetchTasks,
  handleAssetDetailModalState,
  projectId,
  statusList,
  assetID,
  isAssetTogglerOn,
  updateRefreshCounter,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  handleTableScroll,
}) => {
  const classes = useStyles();
  return (
    <>
      <TableContainer className={classes.tableContainer}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead className={classes.tableHeader}>
            <TableRow className={classes.tableRow}>
              <TableCell align="left" className={classes.assetVersionTablecell}>
                Asset Version Name
              </TableCell>
              <TableCell
                align="center"
                className={classes.assetVersionTablecell}
              >
                Added On
              </TableCell>
              <TableCell
                align="center"
                className={classes.assetVersionTablecell}
              >
                Status
              </TableCell>
              <TableCell
                align="center"
                className={classes.assetVersionTablecell}
              >
                Created By
              </TableCell>
              <TableCell
                align="center"
                className={classes.assetVersionTablecell}
              >
                Task Related
              </TableCell>
              <TableCell
                align="center"
                className={classes.assetVersionTablecellTwo}
              >
                Comments
              </TableCell>
              <TableCell
                align="right"
                className={classes.assetVersionTablecellThree}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            className={classes.tableBody}
            onScroll={handleTableScroll}
            ref={tableRef}
            onLoad={() => {
              if (tableRef?.current && tableRef?.current?.scrollTop) {
                tableRef.current.scrollTop = scrollValue;
              }
            }}
            style={{
              height:
                assetVersionList?.count > 50
                  ? `calc(100vh - 292px)`
                  : `calc(100vh - 252px)`,
            }}
          >
            {assetVersionList.results?.map((assetV) => {
              return (
                <Assetversionslist
                  key={assetV.id}
                  taskList={taskList}
                  fetchTasks={fetchTasks}
                  openAssetDetailModal={handleAssetDetailModalState}
                  projectId={projectId}
                  data={assetV}
                  status={statusList}
                  assetID={assetID}
                  isAssetTogglerOn={isAssetTogglerOn}
                  updateRefreshCounter={updateRefreshCounter}
                  dragScreen={dragScreen}
                  handleDragScreen={handleDragScreen}
                  setDragFileEnterModal={setDragFileEnterModal}
                  customFields={assetVersionList.custom_fields}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AssetVersionDefaultTable;
